import t from "./index.es106.js";

var _ = t.t("component_component_timePickerPromptLabel_selectRangeHHMMSS"),
    o = t.t("component_component_timePickerPromptLabel_selectRangeHHMM"),
    n = t.t("component_component_timePickerPromptLabel_selectRangeTime"),
    S = /^\d{1,2}:\d{1,2}(:\d{1,2})? — \d{1,2}:\d{1,2}(:\d{1,2})?$/,
    c = [2, 5, 8, 9, 10, 13, 16],
    I = [2, 5, 6, 7, 10],
    E = [10, 11],
    m = [7, 8];

export { I as DIVIDER_POSITIONS, c as DIVIDER_POSITIONS_WITH_SECONDS, m as INDELIBLE_DASH_POSITIONS, E as INDELIBLE_DASH_POSITIONS_WITH_SECONDS, o as PLACEHOLDER_MASK, _ as PLACEHOLDER_MASK_WITH_SECONDS, n as PLACEHOLDER_SINGLE, S as RANGE_TIME_MASK_REG };